import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {Payroll} from './resource/payroll';
import {BaseService} from '../../core/service/base.service';
import {Observable} from 'rxjs';
import {LocalDate} from '@js-joda/core';
import {PayrollDate} from './resource/payroll-date';
import {PayrollFilter} from './filter/payroll.filter';
import {PayrollApply} from './resource/payroll-apply';
import {Periodicity} from './resource/salary';

@Injectable()
export class PayrollService extends BaseService<Payroll> {

  serviceUrl(): string {
    return `/api/t/{tenant}/payrolls`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  generate(selectedDate: LocalDate, periodicity: Periodicity): Observable<Payroll> {
    const payrollDate = new PayrollDate();
    payrollDate.date = selectedDate;
    payrollDate.periodicity = periodicity;
    return this.http
      .post<Payroll>(`${this.serviceUrl()}/generate`, JSON.stringify(payrollDate));
  }

  apply(payrollDate: LocalDate): Observable<Payroll> {
    const payrollApply = new PayrollApply();
    payrollApply.payrollDate = payrollDate
    return this.http
      .post<Payroll>(`${this.serviceUrl()}/apply`, JSON.stringify(payrollApply));
  }

  sendEmail(payrollIds: number[]): Observable<Payroll> {
    const payrollApply = new PayrollApply();
    payrollApply.payrollIds = payrollIds;
    return this.http
      .post<Payroll>(`${this.serviceUrl()}/resend-email`, JSON.stringify(payrollApply));
  }

  export(filter: PayrollFilter): Observable<any> {
    return this.http.post(`${this.serviceUrl()}/export`, JSON.stringify(filter), {responseType: 'blob'});
  }

  aguinaldoExport(employeeId: number): Observable<any> {
    return this.http.get(`${this.serviceUrl()}/employees/${employeeId}/aguinaldo/export`, {responseType: 'blob'});
  }

}
